import { axiosInstance } from "../../utils";

const actions = {
  LOGIN_REQUESTED: "LOGIN_REQUESTED",
  LOGIN_SUCCEEDED: "LOGIN_SUCCEEDED",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGOUT: "LOGOUT",

  FORGOT_PASSWORD_REQUESTED: "FORGOT_PASSWORD_REQUESTED",
  FORGOT_PASSWORD_SUCCESSDED: "FORGOT_PASSWORD_SUCCESSDED",
  FORGOT_PASSWORD_FAILED: "FORGOT_PASSWORD_FAILED",

  CHECK_CODE_REQUESTED: "CHECK_CODE_REQUESTED",
  CHECK_CODE_SUCCESSDED: "CHECK_CODE_SUCCESSDED",
  CHECK_CODE_FAILED: "CHECK_CODE_FAILED",

  RESET_PASSWORD_REQUESTED: "RESET_PASSWORD_REQUESTED",
  RESET_PASSWORD_SUCCESSDED: "RESET_PASSWORD_SUCCESSDED",
  RESET_PASSWORD_FAILED: "RESET_PASSWORD_FAILED",

  resetPassword: (data) => ({
    type: actions.RESET_PASSWORD_REQUESTED,
    payload: data,
  }),

  forgotPassword: (user) => ({
    type: actions.FORGOT_PASSWORD_REQUESTED,
    payload: user,
  }),

  checkCode: (data) => ({
    type: actions.CHECK_CODE_REQUESTED,
    payload: data,
  }),

  login: (user) => ({
    type: actions.LOGIN_REQUESTED,
    payload: user,
  }),

  setLogin: async (user) => {
    const url = `users/login_by_password`;

    try {
      const newUser = await axiosInstance.post(url, {
        ...user,
        ignore_otp: true,
      });
      return newUser.data;
    } catch (error) {
      throw error;
    }
  },

  sendEmailToForgotPassword: async (user) => {
    const url = `users/forgot_password`;

    try {
      const response = await axiosInstance.post(url, { email: user?.email });
      return response;
    } catch (error) {
      throw error;
    }
  },

  verifyResetCode: async (data) => {
    const url = `users/verify_reset_code`;

    try {
      const response = await axiosInstance.post(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  resetPasswordRequest: async (data) => {
    const url = `users/reset_password`;

    try {
      const response = await axiosInstance.post(url, data);
      return response;
    } catch (error) {
      throw error;
    }
  },

  logout: () => ({
    type: actions.LOGOUT,
  }),
};

export default actions;
